var replaceTemplateStrings = function (line, replace) {
    var regexPattern = new RegExp(Object.keys(replace).join('|'), 'gi');
    return line.replace(regexPattern, function (template) {
        var _a;
        return (_a = replace[template]) !== null && _a !== void 0 ? _a : template;
    });
};
export default replaceTemplateStrings;
